import { render } from "./construction-page.vue?vue&type=template&id=87158262"
import script from "./construction-page.vue?vue&type=script&lang=js"
export * from "./construction-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__